// Este archivo permite cambiar la URL de la API Backend y el dominio de imágenes en todo el soporte frontend.

// API Backend URL
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5100';

// Image Domain - Where profile photos and uploaded images are stored
export const IMAGE_DOMAIN = process.env.REACT_APP_IMAGE_DOMAIN || 'http://localhost:5100';

// Google reCAPTCHA key
export const G_RECAPTCHA = '6Lev8OEqAAAAAFJQj0_31c4qwszGY5jrfgKJRrKH';

export default BASE_URL;